/* eslint-disable react/prop-types */
import React, { useState } from "react";
import components from "./registerComponents";
import { MdArrowBackIosNew } from "react-icons/md";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addModelDashboard } from "../../core/redux/action.jsx";
import KpisFilterModal from "../Filter/kpisFilterModal.jsx";



const Model = ({ onAddChart }) => {
  const translation = useSelector((state) => state.root.translation);
  const dispatch = useDispatch();
  const [nestedList, setNestedList] = useState([]);

  // Getting listKpis2 from Redux state
  const { listKpis2, kpisSelected } = useSelector((state) => state.filter);
  const { index, model } = useSelector((state) => state.root.addModelDetail);
  const [modalClass, setModalClass] = useState("");
  const [modalClass2, setModalClass2] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);  
  
  // Pass listKpis2 to components
  const myComponent = components({ listKpis2 });

  // Handling add chart functionality
  const addChart = (item) => {
    console.log("addChart item",item);
    
    if(item.features) 
    {
      setSelectedItem(item);
      handleShow2();
    }
    else
    {  
      onAddChart(index, item.name, item.size, item.width, item.category,{});
      closeModal();
    }
  };
  const handleSave2 = () => {
    onAddChart(index, selectedItem.name, selectedItem.size, selectedItem.width, selectedItem.category, selectedOptions);
    handleCheckboxChange(false);
    setSelectedOptions({})
    setSelectedItem("");
    handleHide2();
    closeModal();
    
  };

  // Function to get unique objects by comparing categories
  function getUniqueObjects(array, comparator) {
    if (!Array.isArray(array)) return [];
    return array.filter(
      (item, index, self) =>
        item !== undefined &&
        item !== null &&
        index ===
          self.findIndex(
            (obj) => obj !== undefined && obj !== null && comparator(obj, item)
          )
    );
  }
  const handleShow = () => {
    setModalClass("custom-modal-show");
  };
  const handleShow2 = () => {
    setModalClass2("custom-subModal-show");
  };
  
  const handleHide = () => {
    setModalClass("");
  };
  const handleHide2 = () => {
    setModalClass("");
    setModalClass2("");
  };
  // Get unique categories from myComponent instead of components
  const uniqueCate = getUniqueObjects(
    myComponent,
    (a, b) => a && b && a.category && b.category && a.category === b.category
  );

  // Handle category selection
  const categoryHandler = (category) => {
    const findC = myComponent.filter((i) => i.category === category);
    console.log("findC",findC);
  
    setNestedList(findC);
  };
  const handleKpiSelection = (selectedKpis) => {
    const key = selectedItem.name;
    setSelectedOptions((prev) => ({ ...prev, [key]: selectedKpis }));
   
  };
    // Handle checkbox selection
  const handleCheckboxChange = (checked) => {
    setSelectedOptions((prev) => ({
      ...prev,
      enableExports: checked
    }));
  };
  

  // Go back to categories view
  const goBack = () => {
    setNestedList([]);
  };

  // Close the modal
  const closeModal = () => {
    const payload = { model: false, index: "" };
    dispatch(addModelDashboard(payload));
    goBack();
  };

  return (
    <>
    <Modal
      show={model}
      onHide={closeModal}
      onEntered={handleShow} 
      onExited={handleHide} 
      className={modalClass}
      centered
      size="lg"
      dialogClassName="modal-dialog-right"
    >
      {!nestedList.length && (
        <Modal.Header closeButton>
          <Modal.Title>{translation["Select Component"]}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        <div className="component-model">
          {!nestedList.length && (
            <div className="custom-label">
              {uniqueCate?.map((item, i) => (
                <div key={i} onClick={() => categoryHandler(item.category)}>
                  <div className="icon-w">{item.categoryIcon}</div>
                  {item?.category == "KpiCardsNew"?(
                    <p>
                      {translation["cards"] || "Cards"}{" "}
                      </p>
                  ):(
                  <p>{translation[item.category] || item.category}</p>
                  )}
                </div>
              ))}
            </div>
          )}
          {nestedList.length > 0 && (
            <div>
              <div className="modal-header">
                <h5 className="modal-title back-title" onClick={goBack}>
                  <MdArrowBackIosNew /> {translation?.Select}{" "}
                  {nestedList[0]?.category == "TrendCharts" || nestedList[0]?.category == "TrendChartsNew" ? (
                    translation["TrendChartsNew"] || "Trend Chart"
                  ) :  nestedList[0]?.category == "KpiCardsNew" ? (
                    translation["cards"] || "Cards"
                  ): (
                    nestedList[0]?.category
                  )}

                  
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="custom-label">
                {nestedList.map((item, i) => (
                  <div key={i} onClick={() => addChart(item)}>
                    <div className="icon-w">{item.icon}</div>

                    {/* <p>{t(item.name) || item.name}</p> */}
                    {item?.category == "TrendCharts" || item?.category == "TrendChartsNew" ? (
                      <p>
                        {/* {translation[item?.name] || item?.name}{" "} */}
                        {translation["kpi_trend_charts"] || "Kpi Trend Charts"}
                      </p>
                    ) : (
                      <p>{translation[item?.name] || item?.name}</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
    
    {/* //////////////////////////// */}
    <Modal show={modalClass2 === "custom-subModal-show"} onHide={handleHide2} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>{translation["configure_features"] || "Configure Features"}  </Modal.Title>
        </Modal.Header>
       
        <Modal.Body className="overflow-auto" style={{ minHeight: "350px" }} >

          {selectedItem?.features?.map((feature, i) => (
            <div key={i}>
              {feature.kpis && (
                <>
                  {/* SingleSelect or MultiSelect KPIs */}
                  <KpisFilterModal
                    onSelectionChange={handleKpiSelection}
                    isSingleSelect={feature.kpis.type !== "multiselect"}
                  />

                  {/* Checkbox for Enable Exports */}
                  {feature.exports && (
                    <div className="mt-2">
                    <input
                      type="checkbox"
                      id={`exportCheckbox-${i}`}
                      onChange={(e) => handleCheckboxChange(e.target.checked)}
                    />
                      <label htmlFor={`exportCheckbox-${i}`} className="ms-2">
                        Enable Exports
                      </label>
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </Modal.Body>

        <Modal.Footer  className="justify-content-end">
          <Button variant="secondary" onClick={handleHide2}>Close</Button>
          <Button variant="primary" onClick={handleSave2}>Save</Button>
        </Modal.Footer>
    </Modal>
    </>
  );
};

export default Model;